/** Static UI copy for report hub tiles; visibility is driven by OperationMst paths from GET /operations/reports. */
export const REPORT_TILES = [
  {
    path: '/reports/audit',
    title: 'Audit Trail Report',
    description: 'View audit details.',
  },
  {
    path: '/reports/dcf',
    title: "Reviewer's Comments Report",
    description: "Export Reviewer's Comments data to Excel.",
  },
  {
    path: '/reports/action-item',
    title: 'Issue Report',
    description: 'Export Issue data to Excel.',
  },
  {
    path: '/reports/crf-data',
    title: 'Visit Report',
    description: 'Export Visit Report by Site and Visit.',
  },
  {
    path: '/reports/cra-visit',
    title: 'CRA Visit Report',
    description: 'Export visit lifecycle, letters, and report workflow by Site and Visit.',
  },
  {
    path: '/reports/login-logout',
    title: 'Login/Logout Report',
    description: 'Export application, user, login and logout times (UTC), and IP address to Excel.',
  },
];
